// extracted by mini-css-extract-plugin
module.exports = {"page":"PageLanding_page__QVfwG","rotation":"PageLanding_rotation__XbqRz"};